<template>
    <b-modal
        v-model="show"
        centered
        :title="modalTitle"
        lazy
    >
        <!-- Supplier -->
        <b-form-group
            label="Title"
            label-cols="4"
        >
            <b-form-input
                v-model="title"
            />
        </b-form-group>

        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="reset"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                @click="submit"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
import { dispatch, sync } from 'vuex-pathify';

export default {
    computed: {
        ...sync('document', [
            'section@title',
            'section@id',
        ]),
        show: sync('document/showSectionModal'),
        modalTitle() {
            if (this.id) {
                return 'Edit section';
            }

            return 'Add section';
        },
    },
    methods: {
        reset() {
            dispatch('document/setSection', {});
            dispatch('document/setShowSectionModal', false);
        },
        async submit() {
            await dispatch('document/saveSection');
            
            this.reset();
        },
    },
};
</script>

<style scoped>

</style>
